export default __webpack_public_path__ + "static/media/employ_banner.f4afb997.png";